import React from 'react'
import Home from './Home'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import "./Portfolio.css"

const Portfolio = () => {
  return (
    <div>
        
        <Home />
        
        
    </div>
  )
}

export default Portfolio